module.exports = __webpack_public_path__ + "static/media/order_confirmed.21ac9e60.svg";